import React, { useState, useEffect } from 'react';
import { Menu, Box, Button, FormControl, InputLabel, Autocomplete, TextField } from '@mui/material';

const DynamicFilterMenu = ({ data, onFilterChange, isOpen, onClose, selectedFilters, setSelectedFilters, colors }) => {
    const [filterOptions, setFilterOptions] = useState({});

    const ageOrder = ["(No answer)", "18 - 24", "25 - 29", "30 - 34", "35 - 39", "40 - 44", "45 - 49", "50 - 54", "55 - 59", "60 - 64", "Over 64"];
    const tenureOrder = [
        "Less than 5 years",
        "5 - 9 years",
        "10 - 14 years",
        "15 - 19 years",
        "20 years or more",
        "Prefer not to answer"
      ];
    useEffect(() => {
        const raceMergeCategories = ["UNKNOWN", "UNCODED", "UNMATCHED"];
        const genderMergeCategories = ["UNKNOWN", "UNMATCHED", "UNKNOWN"];

        // Preprocess data to clean up race and gender categories
        const preprocessedData = data.map(item => {
            let newItem = {...item};
            if (raceMergeCategories.includes(newItem.RACE)) {
                newItem.RACE = "UNKNOWN";
            }
            if (newItem.GENDER && genderMergeCategories.includes(newItem.GENDER)) {
                newItem.GENDER = "UNKNOWN";
            }
            return newItem;
        });

        const variables = ['GENDER', 'ROLE', 'AGE', 'TENURE', 'ASSOC'];

        const options = {};
        variables.forEach(variable => {
            const countMap = preprocessedData.reduce((acc, item) => {
                const key = item[variable];
                if (key) {
                    acc[key] = (acc[key] || 0) + 1;
                }
                return acc;
            }, {});

            let sortedOptions = Object.entries(countMap)
                .filter(([_, count]) => count >= 5)
                .map(([key]) => key);

            if (variable === "AGE") {
                sortedOptions = sortedOptions.sort((a, b) => ageOrder.indexOf(a) - ageOrder.indexOf(b));
            } else if (variable === "TENURE") {
                sortedOptions = sortedOptions.sort((a, b) => tenureOrder.indexOf(a) - tenureOrder.indexOf(b));
            }

            options[variable] = sortedOptions;
        });
        setFilterOptions(options);
    }, [data]);

    const handleChange = (filterType, value) => {
        setSelectedFilters({ ...selectedFilters, [filterType]: value });
    };

    const handleSubmit = () => {
        onFilterChange(selectedFilters);
        onClose();
    };

    return (
        <Menu open={isOpen} onClose={onClose}>
            {Object.entries(filterOptions).map(([variable, options]) => (
                <Box key={variable} sx={{ m: 1, width: 300 }}>
                    <FormControl fullWidth>
                        <Autocomplete
                            multiple
                            options={options}
                            getOptionLabel={(option) => option}
                            value={selectedFilters[variable] || []}
                            onChange={(event, newValue) => handleChange(variable, newValue)}
                            renderInput={(params) => <TextField {...params} label={variable} />}
                            ListboxProps={{ style: { maxHeight: '200px', overflow: 'auto' } }}
                        />
                    </FormControl>
                </Box>
            ))}
            <Box sx={{ m: 1 }}>
                <Button variant="contained" onClick={handleSubmit} style={{
                    backgroundColor: colors.secondary,
                    color: 'white',
                }}>Apply Filters</Button>
            </Box>
        </Menu>
    );
};

export default DynamicFilterMenu;
